import { Checkbox } from 'components/Checkbox';
import { Container } from 'components/Layout';
import { Controller, useFormContext } from 'react-hook-form';
import { AccountProfileForm } from './form';

export function AccountProfilesRepairDetails() {
  const { control, getValues } = useFormContext<AccountProfileForm>();
  const permits = getValues('permits.repairDetailsPermits');
  return (
    <Container direction="column">
      {permits.map((permit, index) => (
        <Controller
          key={permit.accountProfilePermitId}
          render={({ field }) => (
            <Checkbox
              {...field}
              label={`${permit.name} (${permit.permit})`}
              checked={field.value}
              onChange={field.onChange}
            />
          )}
          name={`permits.repairDetailsPermits.${index}.isActive`}
          control={control}
          defaultValue={false}
        />
      ))}
    </Container>
  );
}
